import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Building2, ShieldCheck } from "lucide-react";

import api, { API } from "../lib/api";
import RazorpayCheckoutButton from "../components/RazorpayCheckoutButton";
import { Loading } from "../components/shared";

export default function PublicBillPayment() {
  const { token } = useParams();
  const [session, setSession] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`${API}/public/fresh-finance/payments/${token}`)
      .then((response) => setSession(response.data))
      .catch((requestError) => {
        setError(requestError.response?.data?.detail || "This payment link is unavailable.");
      });
  }, [token]);

  if (error) {
    return (
      <main className="min-h-screen bg-slate-50 p-5 sm:p-10" data-testid="public-payment-error">
        <section className="mx-auto max-w-lg border border-rose-200 bg-white p-8 shadow-sm">
          <p className="text-sm font-semibold text-rose-700">Payment link unavailable</p>
          <h1 className="mt-2 font-display text-3xl font-bold text-slate-900">We could not open this bill</h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">{error}</p>
        </section>
      </main>
    );
  }
  if (!session) return <Loading />;

  return (
    <main className="min-h-screen bg-slate-50 p-5 sm:p-10" data-testid="public-bill-payment-page">
      <section className="mx-auto max-w-lg border border-slate-200 bg-white p-7 shadow-sm sm:p-10">
        <div className="flex items-center gap-3 text-sky-700">
          <Building2 className="h-6 w-6" />
          <p className="text-sm font-semibold">{session.society_name}</p>
        </div>
        <p className="mt-8 text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
          Secure maintenance payment
        </p>
        <h1 className="mt-2 font-display text-3xl font-bold text-slate-950">
          {session.bill_number}
        </h1>
        <p className="mt-2 text-sm text-slate-600">Unit {session.unit_number}</p>
        <p className="mt-8 text-4xl font-semibold text-slate-950" data-testid="public-payment-amount">
          ₹{Number(session.amount).toFixed(2)}
        </p>
        <div className="mt-8">
          <RazorpayCheckoutButton
            amount={session.amount}
            publicToken={token}
            societyName={session.society_name}
            testId="public-payment-checkout-button"
          />
        </div>
        <p className="mt-7 flex items-start gap-2 text-xs leading-5 text-slate-500">
          <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
          Payment is posted to the member ledger only after server-side verification.
        </p>
      </section>
    </main>
  );
}